import BaseChannel from "../base_channel";

export default class extends BaseChannel {
  static identifier = "InvoiceAdjustments::WorkflowUpdatedChannel";

  receive(data) {
    super.receive(data);
  }
}
